import * as messageService from "../../services/message.service";
import * as dashboardRpService from '../../services/dashboardRp.service';

const state = {
    dRpData:[],
    dRpThisMonthData:[],
    dRpLastMonthData:[],
    dRpLastYearData:[],

    dRpThisMonthLeadsData:[],
    dRpLastMonthLeadsData:[],
    dRpLastYearLeadsData:[],
    dRIsDashboardLoading:false,
};

const getters = {
    getDRpData:state => (state.dRpData),
    getDRpThisMonthData:state => (state.dRpThisMonthData),
    getDRpLastMonthData:state => (state.dRpLastMonthData),
    getDRpLastYearData:state => (state.dRpLastYearData),
    getDRpThisMonthLeadsData:state => (state.dRpThisMonthLeadsData),
    getDRpLastMonthLeadsData:state => (state.dRpLastMonthLeadsData),
    getDRpLastYearLeadsData:state => (state.dRpLastYearLeadsData),
    getDRIsDashboardLoading:state => (state.dRIsDashboardLoading),
};

const actions = {
    async fetchDRpData({ commit }, rpId ){
        try {
            const response = await dashboardRpService.all(rpId);
            commit('setDRpData', response.data);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
        }
    },
    async fetchDRpThisMonthData({ commit }, rpId ){
        try {
            commit('setDRIsDashboardLoading', true);
            const response = await dashboardRpService.thisMonth(rpId);
            commit('setDRpThisMonthData', response.data);
            commit('setDRIsDashboardLoading', false);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
            commit('setDRIsDashboardLoading', false);
        }
    },
    async fetchDRpLastMonthData({ commit }, rpId ){
        try {
            commit('setDRIsDashboardLoading', true);
            const response = await dashboardRpService.lastMonth(rpId);
            commit('setDRpLastMonthData', response.data);
            commit('setDRIsDashboardLoading', false);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
            commit('setDRIsDashboardLoading', false);
        }
    },
    async fetchDRpLastYearData({ commit }, rpId ){
        try {
            commit('setDRIsDashboardLoading', true);
            const response = await dashboardRpService.lastYear(rpId);
            commit('setDRpLastYearData', response.data);
            commit('setDRIsDashboardLoading', false);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
            commit('setDRIsDashboardLoading', false);
        }
    },


    async fetchDRpThisMonthLeadsData({ commit }, rpId ){
        try {
            commit('setDRIsDashboardLoading', true);
            const response = await dashboardRpService.thisMonthLeads(rpId);
            commit('setDRpThisMonthLeadsData', response.data);
            commit('setDRIsDashboardLoading', false);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
            commit('setDRIsDashboardLoading', false);
        }
    },
    async fetchDRpLastMonthLeadsData({ commit }, rpId ){
        try {
            commit('setDRIsDashboardLoading', true);
            const response = await dashboardRpService.lastMonthLeads(rpId);
            commit('setDRpLastMonthLeadsData', response.data);
            commit('setDRIsDashboardLoading', false);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
            commit('setDRIsDashboardLoading', false);
        }
    },
    async fetchDRpLastYearLeadsData({ commit }, rpId ){
        try {
            commit('setDRIsDashboardLoading', true);
            const response = await dashboardRpService.lastYearLeads(rpId);
            commit('setDRpLastYearLeadsData', response.data);
            commit('setDRIsDashboardLoading', false);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
            commit('setDRIsDashboardLoading', false);
        }
    },
};

const mutations = {
    setDRpData:(state, res) => (
        state.dRpData =  res
    ),
    setDRpThisMonthData:(state, res) => (
        state.dRpThisMonthData =  res
    ),
    setDRpLastMonthData:(state, res) => (
        state.dRpLastMonthData =  res
    ),
    setDRpLastYearData:(state, res) => (
        state.dRpLastYearData =  res
    ),
    setDRpThisMonthLeadsData:(state, res) => (
        state.dRpThisMonthLeadsData =  res
    ),
    setDRpLastMonthLeadsData:(state, res) => (
        state.dRpLastMonthLeadsData =  res
    ),
    setDRpLastYearLeadsData:(state, res) => (
        state.dRpLastYearLeadsData =  res
    ),
    setDRIsDashboardLoading:(state, res) => (
        state.dRIsDashboardLoading =  res
    ),
};

export default{
    state,
    getters,
    actions,
    mutations,
}